import React, { Component } from "react";
import PropTypes from "prop-types";
import SVG from "../../../../components/SVG";
import { Row, Col, SectionTitle } from "../../../../components/simple";

import AvatarUpload from "../AvatarUpload";

import Api from "../../../../api";

import styles from "../account-profile.module.scss";

class CompanyDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.user.company?.name,
      isNameEditable: false
    };
    this.nameRef = React.createRef();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.user !== this.props.user) {
      this.setState({ name: newProps.user.company?.name });
    }
  }

  handleNameChange = e => {
    this.setState({ name: e.target.value });
  };

  render() {
    const { user } = this.props;
    const { name, isNameEditable } = this.state;

    return (
      <Row>
        <Col md={6}>
          <div
            className={`${styles["section-title"]} ${styles["section-title-details"]}`}
          >
            <SectionTitle title="Company Details" />
          </div>
          <div className={styles["details-fields-list"]}>
            <div className={styles["details-field"]}>
              <div className={styles["details-field-label"]}>Company name</div>
              <div className={styles["details-field-input-wrapper"]}>
                <div className={styles["details-field-input-container"]}>
                  <input
                    ref={this.nameRef}
                    className={styles.input}
                    value={name}
                    onChange={this.handleNameChange}
                    disabled={!isNameEditable}
                    onBlur={() => {
                      this.setState({ isNameEditable: false }, () => {
                        // TODO: refactor this
                        Api.user
                          .updateCompany({
                            id: user.company.id,
                            data: {
                              name: name.trim()
                            }
                          })
                          .then(() => {
                            Api.user.getUserInfo({ id: user.id });
                          });
                      });
                    }}
                  />
                </div>
                <div className={styles["details-field-edit-button-container"]}>
                  <button
                    type="button"
                    className={styles["details-field-edit-button"]}
                    onClick={() => {
                      this.setState({ isNameEditable: true }, () => {
                        this.nameRef.current.focus();
                      });
                    }}
                  >
                    <SVG.Edit width={15} height={15} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col md={6}>
          <AvatarUpload photo={user?.company?.logo} type="companyAvatar" />
        </Col>
      </Row>
    );
  }
}

CompanyDetails.propTypes = {
  user: PropTypes.shape({
    company: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      logo: PropTypes.string
    }),
    id: PropTypes.string
  }).isRequired
};

export default CompanyDetails;
